export const CMS_RESPONSE = {
  title:
    'Oferta especial pra você: Anuidade zero no cartão SX e conta gratuita.',
  subtitle:
    'Aproveite o que mais espera de um cartão e o que precisa em uma conta!',
  id: '1491566360121',
  components: {
    _onboardingcmc_componente_proposta_banner: {
      name: '_onboardingcmc_componente_proposta_banner',
      'campo-banner': {
        DescricaoImagemProposta: 'campo-landing-top-banner',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/campo-landing-top-banner-cmc/21-11-30_202849_G_axxx_cartao_mais_conta_lp_fase2_desk_1920x449_v0_061021.jpg',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/campo-landing-top-banner-cmc/21-11-30_202849_M_axxx_cartao_mais_conta_lp_fase2_mobile_412x550_v0_061021.jpg',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/campo-landing-top-banner-cmc/21-11-30_202849_P_axxx_cartao_mais_conta_lp_fase2_desk_1920x449_v0_061021.jpg',
        name: 'campo-landing-top-banner-cmc',
        id: '1491566482690',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491566481550',
    },
    _onboardingcmc_componente_documento_cpf: {
      _onboardingpf_componente_input_label: 'INSIRA SEU CPF',
      _onboardingpf_componente_input_validator_invalidFormat:
        'Esse número de CPF é inválido',
      name: '_onboardingcmc_componente_documento_cpf',
      _onboardingpf_componente_input_validator_required: 'Campo obrigatório',
      type: '_onboardingpf_componente_input',
      id: '1491566408232',
    },
    _onboardingcmc_componente_section_offers: {
      _onboardingpf_componente_section_items: [
        {
          _onboardingpf_componente_item_title: '10% DE CASHBACK NAS COMPRAS',
          subtype: '_onboardingpf_componente_item',
          name: '_onboardingcmc_componente_section_offers_1',
          id: '1491566409643',
          _onboardingpf_componente_item_description:
            '<div>Receba de volta, direto na fatura, 10% do valor das primeiras compras com seu novo cart&atilde;o, limitado a R$ 100.</div>\r\n',
          _onboardingpf_componente_item_icon: 'gift',
        },
        {
          _onboardingpf_componente_item_title: '10% DE AUMENTO NO LIMITE',
          subtype: '_onboardingpf_componente_item',
          name: '_onboardingcmc_componente_section_offers_2',
          id: '1491566412024',
          _onboardingpf_componente_item_description:
            '<div>Precisou de um limite extra no cart&atilde;o de cr&eacute;dito? O Santander pode te dar, assim que voc&ecirc; fizer o pagamento da primeira fatura.</div>\r\n\r\n<div>&nbsp;</div>\r\n\r\n<div>&nbsp;</div>\r\n',
          _onboardingpf_componente_item_icon: 'calendar',
        },
      ],
      _onboardingpf_componente_section_title:
        '<div><strong>Veja aqui as facilidades de Cart&atilde;o + Conta</strong>&sup1;</div>\r\n',
      name: '_onboardingcmc_componente_section_offers',
      type: '_onboardingpf_componente_section',
      id: '1491566408889',
    },
    _onboardingcmc_componente_open_account: {
      _onboardingpf_componente_button_primary: 'Sim',
      _onboardingpf_componente_button_label: 'EU QUERO',
      name: '_onboardingcmc_componente_open_account',
      type: '_onboardingpf_componente_button',
      id: '1491566408677',
    },
    _onboardingcmc_componente_boxes: {
      _onboardingpf_componente_item_subtitle:
        'Eleito o melhor do Brasil e América Latina⁵.',
      _onboardingpf_componente_item_title:
        'A segurança é com a gente, a satisfação é sua',
      name: '_onboardingcmc_componente_boxes',
      _onboardingpf_componente_item_description:
        '<div>Com sede na Espanha, o Santander conta com a credibilidade de um dos maiores e mais importantes bancos do mundo.&nbsp;</div>\r\n\r\n<div>&nbsp;</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566593138',
    },
    _onboardingcmc_componente_legal: {
      _onboardingpf_componente_item_title: 'Legal',
      name: '_onboardingcmc_componente_legal',
      _onboardingpf_componente_item_description:
        '<div class="mob-text-2 mb-64 mb-lg-80">\r\n<div>1. Os produtos mencionados podem ser contratados de maneira independente e est&atilde;o sujeitos a aprova&ccedil;&atilde;o de cr&eacute;dito e cadastro. Condi&ccedil;&otilde;es v&aacute;lidas somente para contrata&ccedil;&atilde;o de Cart&atilde;o SX e conta corrente, neste canal.&nbsp;</div>\r\n\r\n<div>2. Na fatura em que n&atilde;o forem acumulados R$ 100 em compras ou no m&ecirc;s em que n&atilde;o for identificado a manuten&ccedil;&atilde;o do cadastro do CPF e do celular como as chaves Pix ser&aacute; cobrado o valor da anuidade do cart&atilde;o, que corresponde a 1/12 do valor divulgado na Tabela de Servi&ccedil;os.</div>\r\n\r\n<div>3. Os 10 dias sem juros ser&atilde;o mantidos sem exig&ecirc;ncia de contrapartidas ou condi&ccedil;&otilde;es adicionais para clientes beneficiados com condi&ccedil;&otilde;es espec&iacute;ficas negociadas entre o Santander e seu empregador e para clientes Private e DUO.</div>\r\n\r\n<div>4. Sujeito &agrave;&nbsp;an&aacute;lise cadastral.</div>\r\n\r\n<div>5. Fonte: Euromoney 2019.</div>\r\n\r\n<p><!--EndFragment --></p>\r\n\r\n<p>&nbsp;</p>\r\n</div>\r\n<style type="text/css">body{font-family:Arial,sans-serif;font-size:10pt;}\r\n</style>\r\n<style type="text/css">.cf0{font-family:Segoe UI;font-size:9pt;}\r\n</style>\r\n<style type="text/css">body{font-family:Arial,sans-serif;font-size:10pt;}\r\n</style>\r\n<style type="text/css">.cf0{font-family:Segoe UI;font-size:9pt;}\r\n</style>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566490164',
    },
    _onboardingcmc_componente_img_boxes: {
      name: '_onboardingcmc_componente_img_boxes',
      'campo-banner': {
        DescricaoImagemProposta: 'Imagens que ficam no boxer',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/campo-boxer-cmc/21-12-01_144649_G_cartoes_sx.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/campo-boxer-cmc/21-12-01_144649_M_21-09-17_161631_p_santandermobile.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/campo-boxer-cmc/21-12-01_144649_P_microsoftteams-image+%2827%29.png',
        name: 'campo-boxer-cmc',
        id: '1491566475793',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491566474623',
    },
    _onboardingcmc_componente_boxes_2: {
      _onboardingpf_componente_item_subtitle:
        'Aproveite os benefícios que você mais espera e precisa!',
      name: '_onboardingcmc_componente_boxes_2',
      _onboardingpf_componente_item_description:
        '<div><span style="font-size:16px"><strong>Aproveite os benef&iacute;cios que voc&ecirc; mais espera e precisa!</strong></span></div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566471691',
    },
    _onboardingcmc_componente_offer: {
      _onboardingpf_componente_item_title:
        'Veja aqui as facilidades de Cartão + Conta¹',
      name: '_onboardingcmc_componente_offer',
      type: '_onboardingpf_componente_item',
      id: '1491566427549',
    },
    _onboardingcmc_componente_offer_1: {
      _onboardingpf_componente_item_title: 'CARTÃO SX COM ANUIDADE ZERO¹',
      name: '_onboardingcmc_componente_offer_1',
      _onboardingpf_componente_item_description:
        '<div>Acumulando R$100 em compras por fatura ou ao cadastrar e manter o CPF e celular como chaves Pix no Santander.</div>\r\n',
      _onboardingpf_componente_item_icon: 'redemption-dollar',
      type: '_onboardingpf_componente_item',
      id: '1491566429370',
    },
    _onboardingcmc_componente_offer_2: {
      _onboardingpf_componente_item_title:
        '10 DIAS SEM JUROS³ NO LIMITE DA CONTA ',
      name: '_onboardingcmc_componente_offer_2',
      _onboardingpf_componente_item_description:
        '<div>Cadastre e mantenha o CPF ou celular como chave Pix no Santander e ganhe um f&ocirc;lego para gerenciar gastos inesperados.</div>\r\n',
      _onboardingpf_componente_item_icon: 'direct-money',
      type: '_onboardingpf_componente_item',
      id: '1491566429686',
    },
    _onboardingcmc_componente_card: {
      _onboardingpf_componente_item_subtitle: 'Conheça mais do cartão SX',
      _onboardingpf_componente_item_title: 'PEÇA AGORA CARTÃO + CONTA!',
      name: '_onboardingcmc_componente_card',
      _onboardingpf_componente_item_description:
        '<div>Tenha um Cart&atilde;o Online antes mesmo do f&iacute;sico chegar, controle seus gastos com o app Way e ainda tenha a possibilidade de ficar livre da anuidade&sup1;.</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566466618',
    },
    _onboardingcmc_componente_card_link: {
      _onboardingpf_componente_item_title:
        'https://www.santander.com.br/fazer-cartao-credito/lead/sx?ic=vitrine',
      name: '_onboardingcmc_componente_card_link',
      type: '_onboardingpf_componente_item',
      id: '1491566467290',
    },
    _onboardingpf_componente_card_image: {
      name: '_onboardingpf_componente_card_image',
      'campo-banner': {
        DescricaoImagemProposta: 'Cartões',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingpf_componente_card_image/22-09-26_123139_G_cartao2.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingpf_componente_card_image/22-09-26_123139_M_cartao2.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingpf_componente_card_image/22-09-26_123139_P_cartao2.png',
        name: '_onboardingpf_componente_card_image',
        id: '1491562784793',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491562784938',
    },
    _onboardingcmc_componente_bennefits_price_section: {
      _onboardingpf_componente_item_title:
        'SANTANDER DIGITAL: SEU BANCO QUANDO E ONDE VOCÊ MAIS PRECISA.',
      name: '_onboardingcmc_componente_bennefits_price_section',
      _onboardingpf_componente_item_description:
        '<div>Tenha o Santander direto no seu celular, computador ou tablet. Tudo na palma da m&atilde;o!</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566465629',
    },
    _onboardingpf_componente_benefits: {
      _onboardingpf_componente_item_subtitle:
        'Isso não é taxa, é serviço de qualidade com transparência.',
      _onboardingpf_componente_item_title:
        'Sobre os valores dos nossos pacotes',
      name: '_onboardingpf_componente_benefits',
      _onboardingpf_componente_item_description:
        'Oferecemos cestas de serviços que são ideais para cada necessidade dos nossos clientes',
      type: '_onboardingpf_componente_item',
      id: '1491557239104',
    },
    _onboarding_componente_card_and_mobile: {
      name: '_onboarding_componente_card_and_mobile',
      'campo-banner': {
        DescricaoImagemProposta: 'Imagem do cartão e do mobile',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboarding_componente_card_and_mobile/21-11-11_212858_G_lp_img_pack_desk.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboarding_componente_card_and_mobile/21-11-11_212858_M_mockup_abra+sua+conta2+%281%29+%281%29.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboarding_componente_card_and_mobile/21-11-11_212858_P_lp_img_pack_desk.png',
        name: '_onboarding_componente_card_and_mobile',
        id: '1491557239166',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491557239575',
    },
    _onboardingcmc_componentes_step_by_step: {
      _onboardingpf_componente_item_title:
        'Abra sua conta de onde estiver e já comece a usar⁴:',
      name: '_onboardingcmc_componentes_step_by_step',
      _onboardingpf_componente_item_description:
        '<div class="mob-info">\r\n<div class="mob-text-6 mob-num">1</div>\r\n\r\n<div class="mob-text-7"><strong>&Eacute; pr&aacute;tico:</strong> digite seu CPF, preencha seus dados;</div>\r\n</div>\r\n\r\n<div class="mob-hr">&nbsp;</div>\r\n\r\n<div class="mob-info">\r\n<div class="mob-text-6 mob-num">2</div>\r\n\r\n<div class="mob-text-7"><strong>&Eacute; r&aacute;pido: </strong>tire uma selfie;</div>\r\n</div>\r\n\r\n<div class="mob-hr">&nbsp;</div>\r\n\r\n<div class="mob-info">\r\n<div class="mob-text-6 mob-num">3</div>\r\n\r\n<div class="mob-text-7"><strong>&Eacute; seguro:</strong> tire uma foto da frente e verso do seu RG ou CNH.</div>\r\n</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566469487',
    },
    _onboardingcmc_componentes_step_by_step_image: {
      name: '_onboardingcmc_componentes_step_by_step_image',
      'campo-banner': {
        DescricaoImagemProposta: 'Passo a passo',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingcmc_componentes_step_by_step_image/21-11-12_224433_G_mockup_abra+sua+conta2+%281%29+%281%29.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingcmc_componentes_step_by_step_image/21-11-12_224433_M_mockup_abra+sua+conta2+%281%29+%281%29.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingcmc_componentes_step_by_step_image/21-11-12_224433_P_mockup_abra+sua+conta2+%281%29+%281%29.png',
        name: '_onboardingcmc_componentes_step_by_step_image',
        id: '1491566470325',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491566469950',
    },
    _onboardingcmc_componentes_step_by_step_footer: {
      _onboardingpf_componente_item_title: 'LEVA SÓ ALGUNS MINUTOS!',
      name: '_onboardingcmc_componentes_step_by_step_footer',
      _onboardingpf_componente_item_description:
        '<div>E o melhor: durante o per&iacute;odo de abertura, voc&ecirc; pode configurar a senha de acesso aos canais e come&ccedil;ar a movimentar sua conta assim que ela for aprovada. Ainda tem d&uacute;vidas?&nbsp;&nbsp;<a class="mob-boston" href="https://www.santander.com.br/conta-corrente-pessoa-fisica">Clique&nbsp;aqui.</a></div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566470941',
    },
    _onboardingpf_componente_offer_icon: {
      name: '_onboardingpf_componente_offer_icon',
      'campo-banner': {
        DescricaoImagemProposta: 'Icones do campo offer',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboarding_campo_offer/21-05-03_145249_G_svgviewer-png-output.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboarding_campo_offer/21-05-03_145249_M_svgviewer-png-output+%281%29.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboarding_campo_offer/21-05-03_145249_P_svgviewer-png-output+%281%29.png',
        name: '_onboarding_campo_offer',
        id: '1491557240017',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491557240355',
    },
    _onboardingpf_componentes_imagem_boxes: {
      name: '_onboardingpf_componentes_imagem_boxes',
      'campo-banner': {
        DescricaoImagemProposta: 'Campos da imagem boxes',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_campo_imagem_boxes/21-05-03_145332_G_girlmobile.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_campo_imagem_boxes/21-05-03_145332_M_santandermobile.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_campo_imagem_boxes/21-05-03_145332_P_girlmobile.png',
        name: '_campo_imagem_boxes',
        id: '1491557281116',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491557282873',
    },
    _onboardingpf_component_imagem_boxes_2: {
      name: '_onboardingpf_component_imagem_boxes_2',
      'campo-banner': {
        DescricaoImagemProposta: 'Segunda camada de fotos',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_campos_imagem_boxes_2/21-10-11_121307_G_lp_img_pack_desk.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_campos_imagem_boxes_2/21-10-11_121307_M_mockup_abra+sua+conta2+%281%29.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_campos_imagem_boxes_2/21-10-11_121307_P_lp_img_pack_desk.png',
        name: '_campos_imagem_boxes_2',
        id: '1491557283306',
      },
      type: '_onboardingpf_componente_banner',
      id: '1491557283970',
    },
    _onboardingcmc_componente_footer: {
      _onboardingpf_componente_item_title: 'footer',
      name: '_onboardingcmc_componente_footer',
      _onboardingpf_componente_item_description:
        '<div class="mob-text-2">&copy;Banco Santander (Brasil) S.A., CNPJ: 90.400.888/0001-42<br />\r\nAv. Presidente Juscelino Kubitscheck 2041/2235 &ndash; Vila Ol&iacute;mpia &ndash; S&atilde;o Paulo/SP.</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491566490806',
    },
    _onboardingcmc_component_productCard_cartao_flow_sx: {
      _onboardingpf_componente_productCard_details_period_name: null,
      _onboardingpf_componente_productCard_details_conditions:
        'Você não paga anuidade ao gastar R$ 100,00 em cada fatura ou se cadastrar seu CPF e celular como chaves Pix no Santander',
      _onboardingpf_componente_productCard_benefits: [
        {
          _onboardingpf_componente_item_title: null,
          subtype: '_onboardingpf_componente_item',
          name: '_onboardingcmc_component_item_beneficios_flow_sx_1',
          id: '1491566693497',
          _onboardingpf_componente_item_description:
            '<div>Livre de anuidade acumulando no m&iacute;nimo R$ 100 no cr&eacute;dito a cada fatura ou cadastrando e mantendo o CPF e celular como chaves Pix no Santander.</div>\r\n',
        },
        {
          _onboardingpf_componente_item_title: null,
          subtype: '_onboardingpf_componente_item',
          name: '_onboardingcmc_component_item_beneficios_flow_sx_2',
          id: '1491566693613',
          _onboardingpf_componente_item_description:
            'Descontos e cashback em diversos parceiros Esfera ao comprar no crédito\r\n',
        },
      ],
      _onboardingpf_componente_productCard_title: 'CARTÃO SANTANDER SX',
      name: '_onboardingcmc_component_productCard_cartao_flow_sx',
      _onboardingpf_componente_productCard_image: {
        DescricaoImagemProposta: 'Imagem do cartão SX',
        GrandeImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingpf_componente_productCard_image_cartaoSX/21-03-02_234109_M_cartao-sx.png',
        MediaImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingpf_componente_productCard_image_cartaoSX/22-06-30_141457_M_sx_visa_platinum.png',
        subtype: 'ImagemProposta',
        PadraoImagemProposta_bloblink_:
          'https://cmsdlvhk.santanderbr.pre.corp/sites/MOB_Propostas/imagemproposta/_onboardingpf_componente_productCard_image_cartaoSX/22-06-30_141457_P_sx_visa_platinum.png',
        name: '_onboardingpf_componente_productCard_image_cartaoSX',
        id: '1491557365626',
      },
      _onboardingpf_componente_productCard_details_period_price: null,
      _onboardingpf_componente_productCard_subtitle:
        'Benefícios do seu cartão com a conta gratuita',
      _onboardingpf_componente_productCard_details_more_conditions:
        'Caso as condições acima não sejam cumpridas, será cobrado um valor de anuidade de 12x R$ 33,25',
      _onboardingpf_componente_productCard_id: '1327',
      _onboardingpf_componente_productCard_credit_status: 'aprovado',
      type: '_onboardingpf_componente_productCard',
      id: '1491566626221',
    },
    _onboardingcmc_componente_alert_cookie: {
      name: '_onboardingcmc_componente_alert_cookie',
      _onboardingpf_componente_item_description:
        '<div>Este site salva seu hist&oacute;rico de uso. Ao continuar navegando voc&ecirc; concorda com a pol&iacute;tica de <a href="http://www.santander.com.br/institucional-santander/seguranca/sobre-o-uso-de-cookies?&amp;_ga=2.100750977.1479687748.1635273700-640214907.1634244354#xd_co_f=MDg5M2FhNzItYjAxYS00ZWQ1LWFmMDAtZTE3MTY2OGQ4ODU0~">cookies</a> e <a href="http://www.santander.com.br/institucional-santander/seguranca/politica-de-privacidade?_ga=2.100750977.1479687748.1635273700-640214907.1634244354">privacidade</a> .</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491569925101',
    },
    _onboardingcmc_componente_alert_button: {
      _onboardingpf_componente_item_title: 'Ok',
      name: '_onboardingcmc_componente_alert_button',
      type: '_onboardingpf_componente_item',
      id: '1491569926026',
    },
    _onboardingcmc_componente_request_your_card_disclaimer: {
      name: '_onboardingcmc_componente_request_your_card_disclaimer',
      _onboardingpf_componente_item_description:
        '<div>N&atilde;o quer aproveitar os benef&iacute;cios da conta gratuita? <a href="https://www.santander.com.br/fazer-cartao-credito/lead/sx?ic=vitrine">Clique aqui</a> e pe&ccedil;a seu cart&atilde;o.</div>\r\n',
      type: '_onboardingpf_componente_item',
      id: '1491570231544',
    },
  },
};
